import MaxAllowedDevicesModal from './MaxAllowedDevicesModal';

export default MaxAllowedDevicesModal;
